import React from 'react';
import { Translate } from 'react-localize-redux';
import getPath from '../../assets/routes/paths';
import getLanguage from '../../services/helpers';

export const getGolfCoursesMenuItems = () => {
  const languageCode = getLanguage();
  const courseLink = getPath(languageCode, 'GolfCourses');

  switch (languageCode) {
    case 'sv':
      return [
        {
          link: `${courseLink}?country=SE`,
          text: <Translate id="navbar.golf-courses.submenu.se" />
        },
        {
          link: `${courseLink}?country=DK`,
          text: <Translate id="navbar.golf-courses.submenu.dk" />
        },
        {
          link: `${courseLink}?country=NO`,
          text: <Translate id="navbar.golf-courses.submenu.no" />
        },
        {
          link: `${courseLink}?country=ES`,
          text: <Translate id="navbar.golf-courses.submenu.es" />
        },
        {
          link: `${courseLink}?country=PT`,
          text: <Translate id="navbar.golf-courses.submenu.pt" />
        },
        {
          link: `${courseLink}?country=IT`,
          text: <Translate id="navbar.golf-courses.submenu.it" />
        }
      ];
    case 'de':
      return [
        {
          link: `${courseLink}?country=DE`,
          text: <Translate id="navbar.golf-courses.submenu.de" />
        },
        {
          link: `${courseLink}?country=AT`,
          text: <Translate id="navbar.golf-courses.submenu.at" />
        },
        {
          link: `${courseLink}?country=DK`,
          text: <Translate id="navbar.golf-courses.submenu.dk" />
        },
        {
          link: `${courseLink}?country=ES`,
          text: <Translate id="navbar.golf-courses.submenu.es" />
        },
        {
          link: `${courseLink}?country=PT`,
          text: <Translate id="navbar.golf-courses.submenu.pt" />
        },
        {
          link: `${courseLink}?country=IT`,
          text: <Translate id="navbar.golf-courses.submenu.it" />
        }
      ];
    case 'dk':
      return [
        {
          link: `${courseLink}?country=DK`,
          text: <Translate id="navbar.golf-courses.submenu.dk" />
        },
        {
          link: `${courseLink}?country=SE`,
          text: <Translate id="navbar.golf-courses.submenu.se" />
        },
        {
          link: `${courseLink}?country=DE`,
          text: <Translate id="navbar.golf-courses.submenu.de" />
        },
        {
          link: `${courseLink}?country=NO`,
          text: <Translate id="navbar.golf-courses.submenu.no" />
        },
        {
          link: `${courseLink}?country=ES`,
          text: <Translate id="navbar.golf-courses.submenu.es" />
        },
        {
          link: `${courseLink}?country=PT`,
          text: <Translate id="navbar.golf-courses.submenu.pt" />
        },
        {
          link: `${courseLink}?country=IT`,
          text: <Translate id="navbar.golf-courses.submenu.it" />
        }
      ];
    case 'no':
      return [
        {
          link: `${courseLink}?country=NO`,
          text: <Translate id="navbar.golf-courses.submenu.no" />
        },
        {
          link: `${courseLink}?country=SE`,
          text: <Translate id="navbar.golf-courses.submenu.se" />
        },
        {
          link: `${courseLink}?country=DK`,
          text: <Translate id="navbar.golf-courses.submenu.dk" />
        },
        {
          link: `${courseLink}?country=ES`,
          text: <Translate id="navbar.golf-courses.submenu.es" />
        },
        {
          link: `${courseLink}?country=PT`,
          text: <Translate id="navbar.golf-courses.submenu.pt" />
        },
        {
          link: `${courseLink}?country=IT`,
          text: <Translate id="navbar.golf-courses.submenu.it" />
        }
      ];
    default:
      return [
        {
          link: `${courseLink}?country=DE`,
          text: <Translate id="navbar.golf-courses.submenu.de" />
        },
        {
          link: `${courseLink}?country=AT`,
          text: <Translate id="navbar.golf-courses.submenu.at" />
        },
        {
          link: `${courseLink}?country=ES`,
          text: <Translate id="navbar.golf-courses.submenu.es" />
        },
        {
          link: `${courseLink}?country=PT`,
          text: <Translate id="navbar.golf-courses.submenu.pt" />
        },
        {
          link: `${courseLink}?country=IT`,
          text: <Translate id="navbar.golf-courses.submenu.it" />
        },
        {
          link: `${courseLink}?country=SE`,
          text: <Translate id="navbar.golf-courses.submenu.se" />
        }
      ];
  }
};
